import { render, staticRenderFns } from "./BatchCountSummaryTable.vue?vue&type=template&id=08c72767"
import script from "./BatchCountSummaryTable.vue?vue&type=script&lang=js"
export * from "./BatchCountSummaryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports